/* YAMAKITS — moteur du panier V8.9 (tiroir custom sections/cart-drawer-yamakits.liquid).
   - Une seule requête réseau par action : change.js / add.js / update.js reçoivent `sections:'cart-drawer-yamakits'` et
     renvoient, dans la même réponse, le HTML de la section rendue avec le panier mis à jour (jauge + corps + pied remplacés).
   - Aucune requête au chargement : l'état initial (lignes, clés, propriétés) est embarqué par Liquid dans #ykCartData.
   - Interface optimiste (quantité, suppression, toggles, badges, taille) ; file queue() : aucun clic perdu, seule la dernière
     action d'une rafale applique le HTML ; la réconciliation des add-ons (_yk_ref/_yk_addon) ne demande le rendu que sur
     son dernier appel. Secours : fetch de section (/?section_id=…) puis /cart.js si `sections` manque ou en cas d'erreur.
   - Config Liquid (ids/prix des suppléments, seuil, délais, images badges) : window.YK_CART_CFG, écrit inline par la section.
   API publique conservée : init, open, close, refresh, add, quickAdd, addItems, change, getCart, goCheckout, applyPromo, removePromo… */
(function(){
'use strict';
var SECTION='cart-drawer-yamakits';

/* ============================================================
   BADGES — données dupliquées du bloc product.json
   IMPORTANT : si tu modifies BADGES, UEFA_COMPS_2526 ou detectTeam dans templates/product.json, mets à jour aussi ici.
   ============================================================ */
var YK_BADGES=[
  {id:'ldc',label:'LDC',full:'Ligue des Champions',color:'#0F4FBF'},
  {id:'ligue1',label:'Ligue 1',full:"Ligue 1 McDonald's",color:'#091C3E'},
  {id:'laliga',label:'La Liga',full:'La Liga EA Sports',color:'#EE1C24'},
  {id:'pl',label:'PL',full:'Premier League',color:'#3D195B'},
  {id:'seriea',label:'Serie A',full:'Serie A',color:'#005FB7'},
  {id:'bundesliga',label:'Bundesliga',full:'Bundesliga',color:'#D20515'},
  {id:'cdm26',label:'CDM 26',full:'Coupe du Monde 2026',color:'#FFD700'},
  {id:'l1champ',label:'L1 Champ.',full:'Champion Ligue 1',color:'#FFD700'},
  {id:'europa',label:'Europa L.',full:'Europa League',color:'#F36C21'},
  {id:'confl',label:'Conf. L.',full:'Conference League',color:'#00A859'},
  {id:'ligaport',label:'Liga Port.',full:'Liga Portugaise',color:'#006633'}
];
var YK_UEFA_2526={
  ldc:['psg','marseille','monaco','real','barca','atletico','athletic','city','arsenal','liverpool','chelsea','newcastle','tottenham','bayern','dortmund','leipzig','leverkusen','stuttgart','frankfurt','inter','milan','juventus','atalanta','bologna','sporting','benfica'],
  europa:['lyon','nice','manu','tottenham','lazio','roma','realsociedad','porto','frankfurt'],
  confl:['lille','rennes','fiorentina','chelsea','realbetis']
};
function ykDetectTeamFromTitle(t){
  t=(t||'').toLowerCase();
  if(t.includes('psg')||t.includes('paris saint')||t.includes('paris sg'))return'psg';
  if(t.includes('marseille')||t.includes('olympique de marseille'))return'marseille';
  if(t.includes('monaco'))return'monaco';
  if(t.includes('lille')||t.includes('losc'))return'lille';
  if(t.includes('lyon')||t.includes('olympique lyonnais'))return'lyon';
  if(t.includes('nice')||t.includes('ogc nice'))return'nice';
  if(t.includes('rennes'))return'rennes';
  if(t.includes('real madrid')||t.includes('real '))return'real';
  if(t.includes('barça')||t.includes('barcelona')||t.includes('barcelone'))return'barca';
  if(t.includes('atletico')||t.includes('atlético'))return'atletico';
  if(t.includes('athletic bilbao')||t.includes('bilbao'))return'athletic';
  if(t.includes('real sociedad'))return'realsociedad';
  if(t.includes('real betis')||t.includes('betis'))return'realbetis';
  if(t.includes('manchester city')||t.includes('man city'))return'city';
  if(t.includes('manchester united')||t.includes('man united')||t.includes('man utd'))return'manu';
  if(t.includes('liverpool'))return'liverpool';
  if(t.includes('chelsea'))return'chelsea';
  if(t.includes('arsenal'))return'arsenal';
  if(t.includes('tottenham')||t.includes('spurs'))return'tottenham';
  if(t.includes('newcastle'))return'newcastle';
  if(t.includes('bayern'))return'bayern';
  if(t.includes('dortmund')||t.includes('borussia dortmund')||t.includes('bvb'))return'dortmund';
  if(t.includes('leipzig')||t.includes('rb leipzig'))return'leipzig';
  if(t.includes('leverkusen')||t.includes('bayer leverkusen'))return'leverkusen';
  if(t.includes('stuttgart'))return'stuttgart';
  if(t.includes('frankfurt')||t.includes('francfort')||t.includes('eintracht'))return'frankfurt';
  if(t.includes('inter milan')||t.includes('inter '))return'inter';
  if(t.includes('milan ac')||t.includes('ac milan'))return'milan';
  if(t.includes('juventus')||t.includes('juve'))return'juventus';
  if(t.includes('atalanta'))return'atalanta';
  if(t.includes('bologna')||t.includes('bologne'))return'bologna';
  if(t.includes('lazio'))return'lazio';
  if(t.includes('roma')||t.includes('as roma'))return'roma';
  if(t.includes('fiorentina'))return'fiorentina';
  if(t.includes('sporting cp')||t.includes('sporting lisbonne')||t.includes('sporting'))return'sporting';
  if(t.includes('benfica')||t.includes('sl benfica'))return'benfica';
  if(t.includes('porto')||t.includes('fc porto'))return'porto';
  if(t.includes('france')||t.includes('équipe de france'))return'france';
  if(t.includes('argentin'))return'argentina';
  if(t.includes('brésil')||t.includes('brazil')||t.includes('bresil'))return'bresil';
  return null;
}
function ykDetectLeagueFromTitle(t){
  t=(t||'').toLowerCase();
  if(/\b(psg|paris saint|paris sg|paris\b|olympique de marseille|\bom\b|marseille|olympique lyonnais|\bol\b|lyon|monaco|lille|losc|rennes|nantes|nice|lens|strasbourg|reims|toulouse|brest|montpellier|auxerre|angers|le havre)\b/.test(t))return'ligue1';
  if(/\b(real madrid|fc barcelona|barça|barcelona|barcelone|atletico|atlético|sevilla|valencia|villarreal|real sociedad|real betis|betis|athletic bilbao|girona|getafe|celta|osasuna|las palmas|mallorca)\b/.test(t))return'laliga';
  if(/\b(manchester city|man city|manchester united|man united|man utd|liverpool|chelsea|arsenal|tottenham|spurs|newcastle|aston villa|west ham|brighton|brentford|crystal palace|fulham|wolves|everton|nottingham|leicester|bournemouth|southampton|leeds)\b/.test(t))return'pl';
  if(/\b(bayern|bayern munich|borussia dortmund|\bbvb\b|dortmund|leverkusen|bayer leverkusen|rb leipzig|leipzig|stuttgart|eintracht|francfort|frankfurt|wolfsburg|hoffenheim|gladbach|werder|union berlin|hertha)\b/.test(t))return'bundesliga';
  if(/\b(juventus|juve|inter milan|\binter\b|ac milan|\bmilan ac\b|\bmilan\b|napoli|naples|as roma|\broma\b|lazio|fiorentina|atalanta|bologna|bologne|torino|udinese|sassuolo|genoa|cagliari|verona|empoli)\b/.test(t))return'seriea';
  if(/\b(porto|fc porto|benfica|sl benfica|sporting cp|sporting lisbonne|sporting|braga|sc braga|vitoria sc|guimaraes|boavista|maritimo)\b/.test(t))return'ligaport';
  if(/\b(france|équipe de france|brésil|brazil|bresil|seleção|argentine|argentina|albiceleste|maroc|morocco|sénégal|senegal|allemagne|germany|deutschland|angleterre|england|three lions|espagne|spain|la roja|italie|italy|azzurra|portugal|belgique|belgium|red devils|pays-bas|netherlands|oranje|croatie|croatia|usa|états-unis|canada|mexique|mexico|japon|japan|corée|korea|côte d'ivoire|nigeria|cameroun|cameroon|tunisie|tunisia|algérie|algeria)\b/.test(t))return'national';
  return null;
}
/* Mode Maison To Sport : passer à false pour afficher tous les badges quel que soit le maillot. */
var YK_BADGES_FILTER_ENABLED=true;
function ykAvailableBadgeIdsForTitle(title){
  var ids=new Set();
  if(!YK_BADGES_FILTER_ENABLED){YK_BADGES.forEach(function(b){ids.add(b.id)});return ids}
  var league=ykDetectLeagueFromTitle(title),team=ykDetectTeamFromTitle(title);
  if(league==='ligue1')ids.add('ligue1');
  if(league==='laliga')ids.add('laliga');
  if(league==='pl')ids.add('pl');
  if(league==='bundesliga')ids.add('bundesliga');
  if(league==='seriea')ids.add('seriea');
  if(league==='ligaport')ids.add('ligaport');
  if(team==='psg')ids.add('l1champ');
  if(team&&YK_UEFA_2526.ldc.indexOf(team)>=0)ids.add('ldc');
  if(team&&YK_UEFA_2526.europa.indexOf(team)>=0)ids.add('europa');
  if(team&&YK_UEFA_2526.confl.indexOf(team)>=0)ids.add('confl');
  if(league==='national')ids.add('cdm26');
  if(ids.size===0)YK_BADGES.forEach(function(b){ids.add(b.id)});
  return ids;
}
function ykBadgePlaceholder(b){
  var ini=b.label.replace(/[^A-Z0-9]/gi,'').slice(0,3).toUpperCase();
  var fz=ini.length>=3?22:28,light=b.color==='#FFD700',tx=light?'#222':'#fff',st=light?'#aaa':'rgba(0,0,0,0.15)';
  return 'data:image/svg+xml;utf8,'+encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><circle cx="50" cy="50" r="46" fill="'+b.color+'" stroke="'+st+'" stroke-width="2"/><text x="50" y="50" text-anchor="middle" dominant-baseline="central" font-family="Arial Black,Arial,sans-serif" font-weight="900" font-size="'+fz+'" fill="'+tx+'">'+ini+'</text></svg>');
}

var JSON_HEADERS={'Content-Type':'application/json','Accept':'application/json'};
var raf=function(){return new Promise(function(r){requestAnimationFrame(function(){r()})})};

window.ykCart={
  d:null,o:null,busy:false,refreshing:false,_q:Promise.resolve(),_pending:0,_last:null,_cart:null,_stale:false,_holdUntil:0,
  ui:{promoOpen:false,noteOpen:false,openKeys:[],badgeKeys:[]},
  addCtx:null,

  init(){
    this.d=document.getElementById('ykD');
    this.o=document.getElementById('ykO');
    if(!this.d||this.d.dataset.ykInit)return;
    this.d.dataset.ykInit='1';
    this._last=this._cart=this.readEmbedded(document);
    this.bind();
    this.afterRender();
    var s=this;
    /* retour arrière (bfcache) : l'état rendu peut être périmé → rafraîchi à la prochaine ouverture seulement */
    window.addEventListener('pageshow',function(e){if(e.persisted)s._stale=true});
    /* add-ons orphelins / désynchronisés laissés par une action interrompue : corrigés sans requête supplémentaire si tout est en ordre */
    if(this._last&&this.planAll(this._last).length)this.queue(function(){return s._last},'init');
  },

  cfg(){return window.YK_CART_CFG||{ids:{},prices:{}}},
  money(cents){return (cents/100).toFixed(2).replace('.',',')+' €'},
  cents(txt){var v=parseFloat(String(txt||'').replace(/[^\d,.-]/g,'').replace(/\.(?=\d{3})/g,'').replace(',','.'));return isNaN(v)?0:Math.round(v*100)},
  newRef(){return 'YK-'+Date.now().toString(36).toUpperCase()},

  /* ---- État embarqué par Liquid (#ykCartData) : lignes/clés/propriétés/remises, sans appel /cart.js */
  readEmbedded(root){
    var el=root&&root.querySelector('#ykCartData');if(!el)return null;
    try{
      var c=JSON.parse(el.textContent||'{}');
      (c.items||[]).forEach(function(it){var p=it.properties,o={};if(Array.isArray(p))p.forEach(function(x){if(Array.isArray(x)&&x.length>=2)o[x[0]]=x[1]});else if(p&&typeof p==='object')o=p;it.properties=o});
      c.items=c.items||[];c.embedded=true;
      return c;
    }catch(e){return null}
  },

  /* ---- API panier ---- */
  async post(url,body){
    var r=await fetch(url,{method:'POST',headers:JSON_HEADERS,body:JSON.stringify(body)});
    var j=null;try{j=await r.json()}catch(e){}
    return {ok:r.ok,status:r.status,data:j,json:function(){return Promise.resolve(j)}};
  },
  async getCart(){var c=await(await fetch('/cart.js?_='+Date.now(),{cache:'no-store'})).json();this._last=c;return c},
  currentCart(){return this._last?Promise.resolve(this._last):this.getCart()},
  waitForCart(){return this.getCart()},
  /* change.js : `final` = dernière requête prévue de la rafale → on demande le rendu de section dans la même réponse */
  async change(key,body,final){
    var b=Object.assign({id:key},body);if(final)b.sections=SECTION;
    var r=await this.post('/cart/change.js',b);
    if(!r.ok||!r.data||!r.data.items)throw new Error('change.js '+r.status+(r.data&&r.data.description?' '+r.data.description:''));
    this._last=r.data;return r.data;
  },
  /* changement de quantité avec prédiction : rendu demandé seulement si aucune réconciliation ne suivra */
  changeQty(cart,key,qty){return this.change(key,{quantity:qty},this.isFinal(this.simQty(cart,key,qty)))},
  /* update.js « updates » par position de ligne : toutes les quantités (article + add-ons) changent en UNE requête.
     qtyByKey = {clé de ligne: nouvelle quantité}. Renvoie le panier (avec sa section rendue si `final`). */
  async applyUpdates(cart,qtyByKey,final){
    var keys=Object.keys(qtyByKey||{});if(!keys.length)return cart;
    var changed=false,updates=(cart.items||[]).map(function(it){var q=Object.prototype.hasOwnProperty.call(qtyByKey,it.key)?qtyByKey[it.key]:it.quantity;if(q!==it.quantity)changed=true;return q});
    if(!changed)return cart;
    var b={updates:updates};if(final)b.sections=SECTION;
    var r=await this.post('/cart/update.js',b);
    if(!r.ok||!r.data||!r.data.items)throw new Error('update.js '+r.status+(r.data&&r.data.description?' '+r.data.description:''));
    this._last=r.data;return r.data;
  },
  /* plan de réconciliation des add-ons → {clé: qté} ; simMap = panier simulé après application d'un plan */
  planMap(cart){var m={};this.planAll(cart).forEach(function(f){m[f.key]=f.qty});return m},
  simMap(cart,map){return {items:(cart.items||[]).map(function(it){return Object.prototype.hasOwnProperty.call(map,it.key)?Object.assign({},it,{quantity:map[it.key]}):it}).filter(function(it){return it.quantity>0})}},
  /* « final » = plus rien d'autre en file (ou seulement des no-ops de la même rafale) et aucune réconciliation à suivre */
  isFinal(sim){return (this._pending<=1||this._soloKey&&this._keys.every(function(x){return x===this._soloKey},this))&&(!sim||this.planAll(sim).length===0)},
  simQty(cart,key,qty){if(!cart||!cart.items)return null;return {items:cart.items.map(function(it){return it.key===key?Object.assign({},it,{quantity:qty}):it}).filter(function(it){return it.quantity>0})}},
  /* add.js renvoie les lignes ajoutées, pas le panier : on demande toujours le rendu de section, dont l'état embarqué
     (#ykCartData) devient le panier courant → r.render = panier + sections, sans appel /cart.js */
  async addItems(items){
    var r=await this.post('/cart/add.js',{items:items,sections:SECTION});
    this._last=null;r.render=null;
    if(r.ok&&r.data&&r.data.sections&&r.data.sections[SECTION]){
      var html=r.data.sections[SECTION],emb=this.readEmbedded(new DOMParser().parseFromString(html,'text/html'));
      if(emb){emb.sections=r.data.sections;r.render=emb;this._last=emb}
    }
    return r;
  },
  isCart(c){return !!(c&&Array.isArray(c.items)&&(c.embedded||typeof c.item_count==='number'))},
  async fetchSection(){
    var r=await fetch('/?section_id='+SECTION+'&_='+Date.now(),{cache:'no-store'});
    if(!r.ok)throw new Error('section '+r.status);
    return r.text();
  },
  /* met à qty toutes les lignes qui matchent, en une seule requête update.js */
  async setQty(match,qty,cart,final){
    cart=cart||await this.currentCart();
    var mk=function(c){var m={};(c.items||[]).forEach(function(x){if(match(x)&&x.quantity!==qty)m[x.key]=qty});return m};
    var m=mk(cart);if(!Object.keys(m).length)return cart;
    try{return await this.applyUpdates(cart,m,final)}
    catch(e){cart=await this.getCart();var m2=mk(cart);return Object.keys(m2).length?this.applyUpdates(cart,m2,final):cart}
  },
  /* nouvelles propriétés sur toutes les lignes du groupe (chaque ligne modifiée quitte la signature d'origine).
     change.js remet la ligne à 1 si `quantity` est omis avec `properties` → on renvoie toujours la quantité de la ligne. */
  async setProps(g,props,cart,finalIfLast){
    cart=cart||await this.currentCart();
    for(var i=0;i<12;i++){
      var lines=this.linesOf(cart,g),it=lines[0];if(!it)return cart;
      var final=!!finalIfLast&&lines.length===1&&this.isFinal(cart);
      try{cart=await this.change(it.key,{quantity:it.quantity,properties:props},final)}catch(e){cart=await this.getCart()}
    }
    return cart;
  },

  /* ---- File d'attente : les actions s'enchaînent (aucun clic perdu) ; réconciliation + rendu une seule fois, après la dernière. */
  queue(fn,label,key){
    var s=this;
    s._pending++;s._keys=s._keys||[];s._keys.push(key||null);
    var job=async function(){
      s.busy=true;s._keys.shift();
      var cart=null;
      try{cart=await fn()}catch(e){console.error('['+label+']',e)}
      s._soloKey=null;s._pending--;
      if(s._pending<=0){
        s._pending=0;
        try{await s.finish(cart)}catch(e){console.error('[render]',e)}
        s.busy=false;
      }
    };
    s._q=s._q.then(job,job);
    return s._q;
  },
  run(fn,label){return this.queue(fn,label)},
  /* fin de rafale : réconcilie les add-ons, puis applique le HTML reçu (ou, à défaut, un rendu de section) */
  async finish(cart){
    var html=cart&&cart.sections&&cart.sections[SECTION]||null;
    if(!this.isCart(cart)){
      if(html){var doc=new DOMParser().parseFromString(html,'text/html');cart=this.readEmbedded(doc)}
      if(!this.isCart(cart)){cart=this.isCart(this._last)?this._last:await this.getCart();html=null}
    }
    var before=cart;
    cart=await this.reconcile(cart);
    if(cart!==before)html=cart.sections&&cart.sections[SECTION]||null;
    if(this._pending>0){this._last=cart;return} /* une nouvelle action attend : elle appliquera son propre rendu */
    if(!html)html=await this.fetchSection();
    await this.applyHtml(html,cart);
  },

  /* Après chaque rendu : livraison, état promo, panneaux ouverts */
  afterRender(){
    this.updateDeliveryDate();
    if(this._cart)this.renderPromo(this._cart);
    this.syncSheet();
    var s=this;
    this.ui.openKeys.forEach(function(k){s.setPanel(k,true)});
    this.ui.badgeKeys.forEach(function(k){s.showBadges(k,true)});
  },

  /* Panneau bas promo / note */
  syncSheet(){
    var sh=document.getElementById('ykSheet'),bg=document.getElementById('ykSheetBg'),t=document.getElementById('ykSheetT');
    var pp=document.getElementById('ykPromo'),np=document.getElementById('ykNote');
    var pb=document.getElementById('ykPromoBtn'),nb=document.getElementById('ykNoteBtn');
    if(!sh)return;
    var open=this.ui.promoOpen||this.ui.noteOpen;
    sh.hidden=!open;if(bg)bg.hidden=!open;
    if(pp)pp.hidden=!this.ui.promoOpen;if(np)np.hidden=!this.ui.noteOpen;
    if(t)t.textContent=this.ui.noteOpen?'Note de commande':'Code promo';
    if(pb)pb.setAttribute('aria-expanded',this.ui.promoOpen?'true':'false');
    if(nb)nb.setAttribute('aria-expanded',this.ui.noteOpen?'true':'false');
    if(open)this.watchKeyboard();else{this.unwatchKeyboard();sh.style.bottom=''}
  },
  openSheet(which){
    this.ui.promoOpen=which==='promo';this.ui.noteOpen=which==='note';
    this.syncSheet();
    var f=document.getElementById(which==='promo'?'ykPromoInput':'ykNoteInput');
    if(f&&!f.hidden&&f.offsetParent!==null){try{f.focus({preventScroll:true})}catch(e){f.focus()}}
  },
  closeSheet(){
    var a=document.activeElement;if(a&&a.blur&&(a.id==='ykPromoInput'||a.id==='ykNoteInput'))a.blur();
    this.ui.promoOpen=false;this.ui.noteOpen=false;this.syncSheet();
  },
  /* iOS/Android : le clavier réduit le visualViewport, on remonte le panneau d'autant */
  watchKeyboard(){
    var vv=window.visualViewport;if(!vv||this._vvOn)return;
    this._vvH=function(){var sh=document.getElementById('ykSheet');if(!sh||sh.hidden)return;var off=Math.max(0,Math.round(window.innerHeight-vv.height-vv.offsetTop));sh.style.bottom=off+'px'};
    vv.addEventListener('resize',this._vvH);vv.addEventListener('scroll',this._vvH);this._vvOn=true;this._vvH();
  },
  unwatchKeyboard(){var vv=window.visualViewport;if(vv&&this._vvOn){vv.removeEventListener('resize',this._vvH);vv.removeEventListener('scroll',this._vvH)}this._vvOn=false},

  updateDeliveryDate(){
    var el=document.getElementById('ykDeliveryText');if(!el)return;
    var c=this.cfg(),dmin=parseInt(c.dmin||this.d.dataset.dmin||'10',10),dmax=parseInt(c.dmax||this.d.dataset.dmax||'12',10);
    var M=['jan','fév','mar','avr','mai','juin','juil','août','sep','oct','nov','déc'];
    var fmt=function(d){return d.getDate()+' '+M[d.getMonth()]};
    var a=new Date(),b=new Date();a.setDate(a.getDate()+dmin);b.setDate(b.getDate()+dmax);
    el.textContent=fmt(a)+' – '+fmt(b);
  },

  /* identité stable d'un article : _yk_ref (la clé de ligne Shopify change à chaque modification de propriété) */
  idOf(el){return (el&&(el.dataset.ref||el.dataset.key))||''},
  find(cls,id){return this.d.querySelector(cls+'[data-ref="'+id+'"]')||this.d.querySelector(cls+'[data-key="'+id+'"]')},

  setPanel(id,open){
    var btn=this.find('.yk-item__edit',id),panel=this.find('.yk-panel',id);
    if(!btn||!panel)return;
    panel.hidden=!open;btn.setAttribute('aria-expanded',open?'true':'false');
    if(open&&!this.ui.openKeys.includes(id))this.ui.openKeys.push(id);
    if(!open)this.ui.openKeys=this.ui.openKeys.filter(function(k){return k!==id});
  },

  showBadges(id,show){
    var box=this.find('.yk-badges',id);if(!box)return;
    box.hidden=!show;
    if(show){this.renderBadgesFor(id);if(!this.ui.badgeKeys.includes(id))this.ui.badgeKeys.push(id)}
    else this.ui.badgeKeys=this.ui.badgeKeys.filter(function(k){return k!==id});
  },

  renderBadgesFor(id){
    var item=this.find('.yk-item',id);var box=item&&item.querySelector('.yk-badges__grid');
    if(!box||box.dataset.rendered==='1')return;
    var title=item.dataset.title||'',current=(item.dataset.badges||'').split(', ').filter(Boolean);
    var allowed=ykAvailableBadgeIdsForTitle(title),assets=this.cfg().badges||{};
    var visible=YK_BADGES.filter(function(b){return allowed.has(b.id)});
    if(!visible.length){box.innerHTML='<div class="yk-badges__empty">Aucun badge disponible pour ce maillot.</div>';box.dataset.rendered='1';return}
    box.innerHTML=visible.map(function(b){var sel=current.includes(b.label),ph=ykBadgePlaceholder(b),src=assets[b.id]||ph;
      return '<button type="button" class="yk-bd" data-badge-id="'+b.id+'" aria-pressed="'+sel+'" title="'+b.full+'"><img src="'+src+'" alt="" width="30" height="30" loading="lazy" decoding="async" onerror="this.onerror=null;this.src=\''+ph+'\'"><span>'+b.label+'</span></button>'}).join('');
    box.dataset.rendered='1';
  },

  bind(){
    var s=this;
    var x=document.getElementById('ykX');if(x)x.addEventListener('click',function(){s.close()});
    if(s.o)s.o.addEventListener('click',function(){s.close()});
    document.addEventListener('keydown',function(e){if(e.key==='Escape'){var m=document.getElementById('ykAdd');if(m&&m.classList.contains('on'))s.closeAdd();else if(s.ui.promoOpen||s.ui.noteOpen)s.closeSheet();else if(s.d.classList.contains('on'))s.close()}});

    s.d.addEventListener('click',function(e){
      if(e.target.closest('#ykAdd')){s.handleAddClick(e);return}
      var plus=e.target.closest('.yk-plus');
      if(plus){s.updateQty(s.cardOf(plus),1);return}
      var minus=e.target.closest('.yk-minus');
      if(minus){var q=parseInt(minus.parentElement.querySelector('.yk-qty__n').textContent,10)||1;var card=s.cardOf(minus);if(q>1)s.updateQty(card,-1);else s.removeGroup(card);return}
      var del=e.target.closest('.yk-item__del');
      if(del){s.removeGroup(s.cardOf(del));return}
      var edit=e.target.closest('.yk-item__edit');
      if(edit){s.setPanel(s.idOf(edit),edit.getAttribute('aria-expanded')!=='true');return}
      var sz=e.target.closest('.yk-item__sizes .yk-chip');
      if(sz&&!sz.classList.contains('on')){sz.parentElement.querySelectorAll('.yk-chip').forEach(function(b){b.classList.remove('on')});sz.classList.add('on');s.updateSize(s.cardOf(sz),sz.dataset.sz);return}
      var flocSave=e.target.closest('.yk-floc__save');
      if(flocSave){s.saveFloc(s.idOf(flocSave.closest('.yk-floc')));return}
      var swB=e.target.closest('.yk-sw--badge');
      if(swB){var on=swB.classList.contains('on');var id=s.idOf(swB.closest('.yk-item'));if(on){swB.classList.remove('on');swB.setAttribute('aria-checked','false');s.showBadges(id,false);s.updateBadges(s.cardOf(swB),[])}else{swB.classList.add('on');swB.setAttribute('aria-checked','true');s.showBadges(id,true)}return}
      var bd=e.target.closest('.yk-bd');
      if(bd){var grid=bd.closest('.yk-badges__grid');bd.setAttribute('aria-pressed',bd.getAttribute('aria-pressed')==='true'?'false':'true');var ids=[].slice.call(grid.querySelectorAll('.yk-bd[aria-pressed="true"]')).map(function(b){return b.dataset.badgeId});s.updateBadges(s.cardOf(bd),ids);return}
      var swS=e.target.closest('.yk-sw--short');
      if(swS){s.toggleShort(swS);return}
      var swP=e.target.closest('.yk-sw--player');
      if(swP){s.toggleVPlayer(swP);return}
      var up=e.target.closest('.yk-up__add');
      if(up){s.openAdd(up);return}
      if(e.target.closest('#ykPromoBtn')){s.openSheet('promo');return}
      if(e.target.closest('#ykNoteBtn')){s.openSheet('note');return}
      if(e.target.closest('#ykSheetX')||e.target.id==='ykSheetBg'){s.closeSheet();return}
      if(e.target.closest('#ykNoteDone')){var ta=document.getElementById('ykNoteInput');if(ta)s.scheduleNote(ta.value,true);s.closeSheet();return}
      if(e.target.closest('#ykPromoApply')){s.applyPromo();return}
      if(e.target.closest('#ykPromoRemove')){s.removePromo();return}
    });

    s.d.addEventListener('keydown',function(e){
      if(e.target.id==='ykPromoInput'&&e.key==='Enter'){e.preventDefault();s.applyPromo()}
      if(e.target.id==='ykNoteInput'&&e.key==='Enter'&&!e.shiftKey){e.preventDefault();s.scheduleNote(e.target.value,true);s.closeSheet()}
      if(e.target.matches('.yk-floc .yk-input')&&e.key==='Enter'){e.preventDefault();var box=e.target.closest('.yk-floc');if(box.dataset.key)s.saveFloc(s.idOf(box));else s.updateAddTotal()}
    });

    s.d.addEventListener('input',function(e){
      var t=e.target;
      if(t.matches('.yk-floc .yk-input')){
        if(t.dataset.field==='num'||t.id==='ykAddNum')t.value=t.value.replace(/\D/g,'');
        else t.value=t.value.toUpperCase();
        var box=t.closest('.yk-floc');
        if(box&&box.dataset.key){var save=box.querySelector('.yk-floc__save');if(save)save.hidden=!s.flocDirty(box)}
        else s.updateAddTotal();
      }
      if(t.id==='ykNoteInput'){var c=document.getElementById('ykNoteCount');if(c)c.textContent=t.value.length;s.scheduleNote(t.value)}
    });

    s.d.addEventListener('focusout',function(e){
      var t=e.target;
      if(t.matches&&t.matches('.yk-floc .yk-input')&&t.closest('.yk-floc').dataset.key){
        var box=t.closest('.yk-floc');
        setTimeout(function(){if(box.contains(document.activeElement))return;if(s.flocDirty(box))s.saveFloc(s.idOf(box))},150);
      }
    });

    s.d.addEventListener('transitionend',function(e){if(e.target===s.d&&e.propertyName==='transform')s.d.classList.remove('anim')});
    var cnt=document.getElementById('ykC');if(cnt)cnt.addEventListener('animationend',function(){cnt.classList.remove('pulse')});
  },

  /* ---- Ouverture / fermeture : transform + opacité, will-change seulement pendant l'animation */
  open(){
    if(!this.d)this.init();if(!this.d)return;
    var d=this.d,s=this;
    if(this._stale){this._stale=false;this.refresh(true)}
    if(d.classList.contains('on'))return;
    d.querySelectorAll('.yk-item').forEach(function(el){el.classList.add('in')});
    d.classList.add('anim');d.classList.add('on');
    if(this.o)this.o.classList.add('on');
    document.body.classList.add('yk-lock');
    clearTimeout(this._animT);this._animT=setTimeout(function(){d.classList.remove('anim')},450);
    this.updateDeliveryDate();
    setTimeout(function(){d.querySelectorAll('.yk-item.in').forEach(function(el){el.classList.remove('in')})},700);
  },
  close(){
    var d=this.d;if(!d)return;
    d.classList.add('anim');d.classList.remove('on');
    if(this.o)this.o.classList.remove('on');
    document.body.classList.remove('yk-lock');
    clearTimeout(this._animT);this._animT=setTimeout(function(){d.classList.remove('anim')},450);
    this.closeAdd();
  },
  loading(v){if(this.d)this.d.classList.toggle('busy',!!v)},

  flocVals(box){var g=function(f){var e=box.querySelector('[data-field="'+f+'"]');return (e&&e.value||'').trim()};return{name:g('name'),num:g('num'),sub:g('sub')}},
  flocDirty(box){return [].slice.call(box.querySelectorAll('.yk-input')).some(function(x){return x.value.trim()!==(x.defaultValue||'').trim()})},

  /* ---- Groupes de lignes : Shopify scinde une ligne (remise automatique « 3 achetés = 1 offert »…) → même variante + mêmes
     propriétés = un seul article ; toutes les mutations s'appliquent au groupe (vid + signature des propriétés). */
  norm(p){var o={};Object.keys(p||{}).sort().forEach(function(k){o[k]=p[k]});return JSON.stringify(o)},
  cardOf(el){return el&&el.closest('.yk-item')},
  grp(card){var props={};try{var raw=JSON.parse(card.dataset.props||'{}');if(Array.isArray(raw))raw.forEach(function(p){if(Array.isArray(p)&&p.length>=2)props[p[0]]=p[1]});else props=raw||{}}catch(e){}return {vid:parseInt(card.dataset.vid,10),sig:this.norm(props)}}, /* Liquid `properties | json` rend un tableau de paires */
  linesOf(cart,g){var s=this;return (cart.items||[]).filter(function(it){return it.variant_id===g.vid&&!(it.properties||{})._yk_addon&&s.norm(it.properties)===g.sig})},
  groupQty(cart,g){return this.linesOf(cart,g).reduce(function(a,x){return a+(x.quantity||0)},0)},

  /* ---- Interface optimiste : totaux, jauge, compteur (corrigés par le rendu serveur qui suit) */
  bump(deltaCents,deltaCount){
    var tot=document.getElementById('ykTotal'),badge=document.getElementById('ykC');
    var total=null;
    if(tot&&deltaCents){total=Math.max(0,this.cents(tot.textContent)+deltaCents);tot.textContent=this.money(total);this.renderGift(total)}
    if(badge&&deltaCount){var n=Math.max(0,(parseInt(badge.textContent,10)||0)+deltaCount);badge.textContent=n;badge.classList.remove('pulse');void badge.offsetWidth;badge.classList.add('pulse');this.syncHeaderCount(n);this.renderPack(n)}
  },
  /* Bloc avantages (V8.9) : même logique que snippets/yk-cart-pack.liquid, appliquée sans requête (quantité + total affichés) */
  renderPack(n){this.renderOffers(n,null)},
  renderGift(total){this.renderOffers(null,total)},
  renderOffers(n,total){
    var el=document.getElementById('ykPack');if(!el)return;
    if(n===null||n===undefined)n=parseInt(el.dataset.n||'0',10)||0;
    if(total===null||total===undefined)total=parseInt(el.dataset.sub||'0',10)||0;
    n=Math.max(0,n|0);total=Math.max(0,total|0);
    var goal=parseInt(el.dataset.goal||'3',10)||3,gmin=parseInt(el.dataset.giftMin||'3500',10),smin=parseInt(el.dataset.shipMin||'6000',10);
    var ok1=true,ok2=true,ok3=n>=goal,done=(ok1?1:0)+(ok2?1:0)+(ok3?1:0),left=goal-n,msg;
    if(n===0)msg='Ajoute une paire pour débloquer ta <strong>3e paire offerte</strong>';
    else if(!ok1)msg='Plus que <strong>'+this.money(gmin-total)+'</strong> pour ta <strong>carte cadeau 5 €</strong>';
    else if(!ok2)msg='Plus que <strong>'+this.money(smin-total)+'</strong> pour la <strong>livraison offerte</strong>';
    else if(!ok3)msg=left===1?'Plus qu’<strong>1 paire</strong> pour la 3e <strong>OFFERTE</strong>':'Plus que <strong>'+left+' paires</strong> pour la 3e <strong>OFFERTE</strong>';
    else msg='<strong>Tout est débloqué</strong> — ta 3e paire est offerte 🔥';
    el.dataset.n=n;el.dataset.sub=total;el.classList.toggle('ok',done===3);
    var h=document.getElementById('ykPackHint'),m=document.getElementById('ykPackMsg');if(h)h.textContent=ok3?'✓':n+'/'+goal;if(m)m.innerHTML=msg;
    var st={gift:[ok1,n>0],ship:[ok2,ok1],pack:[ok3,ok2]};
    el.querySelectorAll('.yk-pack__slot[data-slot]').forEach(function(sl){var s=st[sl.dataset.slot]||[false,false];sl.classList.toggle('done',s[0]);sl.classList.toggle('next',!s[0]&&s[1])});
    el.querySelectorAll('.yk-pack__conn').forEach(function(c){var k=c.dataset.conn;c.classList.toggle('done',k==='1'?ok1:ok2)});
    var g=document.getElementById('ykGauge');if(g)g.hidden=n===0;
  },
  syncHeaderCount(n){document.querySelectorAll('.cart-count,.cart-count-bubble,[data-cart-count]').forEach(function(el){el.textContent=n;el.setAttribute('data-count',n);if('hidden' in el)el.hidden=n===0})},
  unitPrice(card){var pr=card.querySelector('.yk-item__price'),n=card.querySelector('.yk-qty__n');var q=parseInt(n&&n.textContent,10)||1;return Math.round(this.cents(pr&&pr.textContent)/q)},
  setPrice(card,cents){var pr=card.querySelector('.yk-item__price');if(pr)pr.textContent=this.money(cents)},
  /* résumé « Flocage · Badge · Short · Player » et ligne Taille/Version, d'après l'état du panneau */
  refreshSum(card){
    var sum=card.querySelector('.yk-item__sum'),meta=card.querySelector('.yk-item__meta');
    var floc=card.querySelector('.yk-floc'),v=floc?this.flocVals(floc):{},hasFloc=!!(v.name||v.num||v.sub)||/Joueur/.test(card.dataset.props||'');
    var on=function(c){var b=card.querySelector(c);return !!(b&&b.classList.contains('on'))};
    var badgeOn=!!card.querySelector('.yk-bd[aria-pressed="true"]')||(on('.yk-sw--badge')&&!!(card.dataset.badges));
    var bits=[];if(hasFloc)bits.push('Flocage');if(badgeOn)bits.push('Badge');if(on('.yk-sw--short'))bits.push('Short');if(on('.yk-sw--player'))bits.push('Player');
    if(sum)sum.textContent=bits.length?bits.join(' · '):'Aucune option';
    if(meta){var size=card.dataset.size;meta.innerHTML=(size?'Taille '+size+'<i> · </i>':'')+(on('.yk-sw--player')?'Version Player':'Version Fan')}
  },

  /* quantité : affichage immédiat ; une rafale de clics sur le même article est fusionnée en UNE requête (delta cumulé),
     les jobs suivants de la rafale ne font rien (aucun clic perdu, aucune requête inutile) */
  updateQty(card,delta){
    var g=this.grp(card),s=this,k=g.vid+'|'+g.sig;
    var n=card.querySelector('.yk-qty__n');
    var q0=parseInt(n&&n.textContent,10)||1,q1=Math.max(1,q0+delta),unit=this.unitPrice(card);
    if(n)n.textContent=q1;
    if(unit>0)this.setPrice(card,unit*q1);
    this.bump(unit*(q1-q0),q1-q0);
    card.classList.add('busy');
    this._deltas=this._deltas||{};this._deltas[k]=(this._deltas[k]||0)+(q1-q0);
    return this.queue(async function(){
      var dd=s._deltas[k]||0;if(!dd)return s.isCart(s._last)?s._last:null;
      s._deltas[k]=0;s._soloKey=k; /* les jobs restants de la même rafale ne feront rien : cette requête peut porter le rendu */
      var cart=await s.currentCart();var lines=s.linesOf(cart,g);
      if(!lines.length){cart=await s.getCart();lines=s.linesOf(cart,g);if(!lines.length)return cart}
      /* article + add-ons liés dans la même requête update.js (quantités par position de ligne) */
      var apply=async function(cart,lines,dd){
        var m={};
        if(dd>0)m[lines[0].key]=lines[0].quantity+dd;
        else{ /* baisse : on retire d'abord sur les lignes de fin (lignes scindées), jamais sous 1 au total */
          var total=lines.reduce(function(a,x){return a+x.quantity},0),want=Math.max(1,total+dd),excess=total-want;
          for(var i=lines.length-1;i>=0&&excess>0;i--){var take=Math.min(excess,lines[i].quantity-(i===0?1:0));if(take<=0)continue;m[lines[i].key]=lines[i].quantity-take;excess-=take}
        }
        Object.assign(m,s.planMap(s.simMap(cart,m)));
        return s.applyUpdates(cart,m,s.isFinal(null));
      };
      try{return await apply(cart,lines,dd)}
      catch(e){cart=await s.getCart();var l2=s.linesOf(cart,g);if(!l2.length)return cart;return apply(cart,l2,dd)}
    },'updateQty',k);
  },
  /* suppression : l'article se replie immédiatement, requête en parallèle, rendu serveur retenu jusqu'à la fin de l'animation */
  removeGroup(card){
    var g=this.grp(card),s=this;
    if(card.classList.contains('removing'))return this._q;
    var q=parseInt((card.querySelector('.yk-qty__n')||{}).textContent,10)||1,price=this.cents((card.querySelector('.yk-item__price')||{}).textContent);
    var h=card.offsetHeight; /* lecture */
    card.style.height=h+'px';
    requestAnimationFrame(function(){card.classList.add('removing')}); /* écriture au frame suivant → transition */
    this._holdUntil=performance.now()+230;
    this.bump(-price,-q);
    return this.queue(async function(){
      try{
        var match=function(it){return it.variant_id===g.vid&&!(it.properties||{})._yk_addon&&s.norm(it.properties)===g.sig};
        var cart=await s.currentCart(),m={};
        (cart.items||[]).forEach(function(it){if(match(it))m[it.key]=0});
        if(!Object.keys(m).length){cart=await s.getCart();(cart.items||[]).forEach(function(it){if(match(it))m[it.key]=0});if(!Object.keys(m).length)return cart}
        Object.assign(m,s.planMap(s.simMap(cart,m))); /* add-ons du maillot retirés dans la même requête */
        return await s.applyUpdates(cart,m,s.isFinal(null));
      }catch(e){card.classList.remove('removing');card.style.height='';throw e}
    },'remove');
  },

  updateSize(card,newSize){
    var g=this.grp(card),SHORT_ID=this.cfg().ids.short,s=this;
    card.dataset.size=newSize;card.classList.add('busy');this.refreshSum(card);
    return this.queue(async function(){
      var cart=await s.currentCart();var it=s.linesOf(cart,g)[0];if(!it)return cart;
      var ref=it.properties&&it.properties._yk_ref;
      var props=Object.assign({},it.properties,{'Taille':newSize});if(!ref){ref=s.newRef();props['_yk_ref']=ref}
      if(props['Short assorti'])props['Short assorti']='Taille '+newSize;
      var isShort=function(x){var p=x.properties;return !!(p&&p._yk_addon&&p._yk_ref===ref&&x.variant_id===SHORT_ID&&p['Taille']!==newSize)};
      var nShort=cart.items.filter(isShort).length;
      cart=await s.setProps(g,props,cart,nShort===0);
      for(var i=0;i<6;i++){var sh=cart.items.find(isShort);if(!sh)break;var last=cart.items.filter(isShort).length===1;try{cart=await s.change(sh.key,{quantity:sh.quantity,properties:Object.assign({},sh.properties,{'Taille':newSize})},last&&s.isFinal(cart))}catch(e){cart=await s.getCart()}}
      return cart;
    },'updateSize');
  },

  saveFloc(id){var box=this.find('.yk-floc',id);if(!box)return;var v=this.flocVals(box);return this.updateFloc(this.cardOf(box),v.name,v.num,v.sub)},
  updateFloc(card,name,num,sub){
    sub=sub||'';
    var g=this.grp(card),FLOC_ID=this.cfg().ids.floc,P=this.cfg().prices,s=this;
    /* optimiste : prix = nombre d'éléments de flocage × prix unitaire, résumé */
    var box=card.querySelector('.yk-floc');
    if(box){var save=box.querySelector('.yk-floc__save');if(save)save.hidden=true;
      var before=[].slice.call(box.querySelectorAll('.yk-input')).filter(function(x){return (x.defaultValue||'').trim()}).length;
      var after=[name,num,sub].filter(Boolean).length;
      var q=parseInt((card.querySelector('.yk-qty__n')||{}).textContent,10)||1;
      var delta=(after-before)*(P.floc||0)*q;
      if(delta){s.setPrice(card,s.cents((card.querySelector('.yk-item__price')||{}).textContent)+delta);s.bump(delta,0)}
      box.querySelectorAll('.yk-input').forEach(function(x){x.defaultValue=x.value});
      s.refreshSum(card);}
    card.classList.add('busy');
    return this.queue(async function(){
      var cart=await s.currentCart();var lines=s.linesOf(cart,g);var it=lines[0];if(!it)return cart;
      var qty=s.groupQty(cart,g),pour=it.product_title||it.title||'';
      var ref=it.properties&&it.properties._yk_ref;
      var props=Object.assign({},it.properties);if(!ref)ref=s.newRef();props['_yk_ref']=ref;
      delete props['Joueur officiel'];delete props['Joueur'];
      if(name)props['Nom']=name.toUpperCase();else delete props['Nom'];
      if(num)props['Numéro']=num;else delete props['Numéro'];
      if(sub)props['Sous-numéro']=sub.toUpperCase();else delete props['Sous-numéro'];
      var toAdd=[];
      if(name)toAdd.push({id:FLOC_ID,quantity:qty,properties:{'Pour':pour,'Texte':name.toUpperCase(),'_yk_ref':ref,'_yk_addon':'1'}});
      if(num)toAdd.push({id:FLOC_ID,quantity:qty,properties:{'Pour':pour,'Numéro':num,'_yk_ref':ref,'_yk_addon':'1'}});
      if(sub)toAdd.push({id:FLOC_ID,quantity:qty,properties:{'Pour':pour,'Texte':sub.toUpperCase(),'Position':'Sous le numéro','_yk_ref':ref,'_yk_addon':'1'}});
      var isOld=function(x){var p=x.properties;return !!(p&&p._yk_addon&&p._yk_ref===ref&&x.variant_id===FLOC_ID)};
      var hasOld=cart.items.some(isOld);
      cart=await s.setProps(g,props,cart,!hasOld&&!toAdd.length);
      if(hasOld)cart=await s.setQty(isOld,0,cart,!toAdd.length&&s.isFinal(null));
      if(toAdd.length){var r=await s.addItems(toAdd);return r.render}
      return cart;
    },'updateFloc');
  },

  updateBadges(card,badgeIds){
    var g=this.grp(card),BADGE_ID=this.cfg().ids.badge,P=this.cfg().prices,s=this;
    var labels=badgeIds.map(function(id){return (YK_BADGES.find(function(b){return b.id===id})||{}).label}).filter(Boolean);
    /* optimiste : prix selon le nombre de badges, résumé */
    var before=(card.dataset.badges||'').split(', ').filter(Boolean).length,q=parseInt((card.querySelector('.yk-qty__n')||{}).textContent,10)||1;
    var delta=(labels.length-before)*(P.badge||0)*q;
    card.dataset.badges=labels.join(', ');
    if(delta){this.setPrice(card,this.cents((card.querySelector('.yk-item__price')||{}).textContent)+delta);this.bump(delta,0)}
    this.refreshSum(card);card.classList.add('busy');
    return this.queue(async function(){
      var cart=await s.currentCart();var lines=s.linesOf(cart,g);var it=lines[0];if(!it)return cart;
      var qty=s.groupQty(cart,g),pour=it.product_title||it.title||'';
      var ref=it.properties&&it.properties._yk_ref;if(!ref)ref=s.newRef();
      var props=Object.assign({},it.properties);props['_yk_ref']=ref;
      if(labels.length)props['Badges']=labels.join(', ');else delete props['Badges'];
      var match=function(x){var p=x.properties;return !!(p&&p._yk_addon&&p._yk_ref===ref&&x.variant_id===BADGE_ID)};
      var toAdd=badgeIds.map(function(id){var b=YK_BADGES.find(function(x){return x.id===id});return b?{id:BADGE_ID,quantity:qty,properties:{'Pour':pour,'Badge':b.label,'_yk_ref':ref,'_yk_addon':'1'}}:null}).filter(Boolean);
      var hasOld=cart.items.some(match);
      cart=await s.setProps(g,props,cart,!hasOld&&!toAdd.length);
      if(hasOld)cart=await s.setQty(match,0,cart,!toAdd.length&&s.isFinal(null));
      if(toAdd.length){var r=await s.addItems(toAdd);return r.render}
      return cart;
    },'updateBadges');
  },

  toggleShort(btn){
    var card=this.cardOf(btn),g=this.grp(card),SHORT_ID=this.cfg().ids.short,P=this.cfg().prices,s=this;
    var isOn=btn.classList.contains('on');btn.classList.toggle('on');btn.setAttribute('aria-checked',isOn?'false':'true');btn.classList.add('busy');
    var q=parseInt((card.querySelector('.yk-qty__n')||{}).textContent,10)||1,delta=(isOn?-1:1)*(P.short||0)*q;
    this.setPrice(card,this.cents((card.querySelector('.yk-item__price')||{}).textContent)+delta);this.bump(delta,0);this.refreshSum(card);card.classList.add('busy');
    return this.queue(async function(){
      var cart=await s.currentCart();var lines=s.linesOf(cart,g);var it=lines[0];if(!it)return cart;
      var qty=s.groupQty(cart,g),pour=it.product_title||it.title||'';
      var ref=it.properties&&it.properties._yk_ref;
      var props=Object.assign({},it.properties);if(!ref)ref=s.newRef();props['_yk_ref']=ref;
      var size=props['Taille']||btn.dataset.size||'M';
      if(isOn){
        delete props['Short assorti'];delete props['Short'];
        cart=await s.setProps(g,props,cart);
        return s.setQty(function(x){var p=x.properties;return !!(p&&p._yk_addon&&p._yk_ref===ref&&x.variant_id===SHORT_ID)},0,cart,s.isFinal(null));
      }
      props['Short assorti']='Taille '+size;
      await s.setProps(g,props,cart);
      var r=await s.addItems([{id:SHORT_ID,quantity:qty,properties:{'Pour':pour,'Taille':size,'_yk_ref':ref,'_yk_addon':'1'}}]);
      return r.render;
    },'toggleShort');
  },

  toggleVPlayer(btn){
    var card=this.cardOf(btn),g=this.grp(card),VPLAYER_ID=this.cfg().ids.vplayer,P=this.cfg().prices,s=this;
    var isOn=btn.classList.contains('on');btn.classList.toggle('on');btn.setAttribute('aria-checked',isOn?'false':'true');btn.classList.add('busy');
    var q=parseInt((card.querySelector('.yk-qty__n')||{}).textContent,10)||1,delta=(isOn?-1:1)*(P.vplayer||0)*q;
    this.setPrice(card,this.cents((card.querySelector('.yk-item__price')||{}).textContent)+delta);this.bump(delta,0);this.refreshSum(card);card.classList.add('busy');
    return this.queue(async function(){
      var cart=await s.currentCart();var lines=s.linesOf(cart,g);var it=lines[0];if(!it)return cart;
      var qty=s.groupQty(cart,g),pour=it.product_title||it.title||'';
      var ref=it.properties&&it.properties._yk_ref;
      var props=Object.assign({},it.properties);if(!ref)ref=s.newRef();props['_yk_ref']=ref;
      if(isOn){
        delete props['Version Player'];
        cart=await s.setProps(g,props,cart);
        return s.setQty(function(x){var p=x.properties;return !!(p&&p._yk_addon&&p._yk_ref===ref&&x.variant_id===VPLAYER_ID)},0,cart,s.isFinal(null));
      }
      props['Version Player']='Oui';
      await s.setProps(g,props,cart);
      var r=await s.addItems([{id:VPLAYER_ID,quantity:qty,properties:{'Pour':pour,'_yk_ref':ref,'_yk_addon':'1'}}]);
      return r.render;
    },'toggleVPlayer');
  },

  /* Réconciliation : la quantité TOTALE de chaque add-on (même variante + mêmes propriétés, lignes scindées comprises) doit
     égaler la quantité totale de son maillot parent (_yk_ref), 0 si orphelin. On ne fusionne jamais les lignes scindées. */
  planAll(cart){
    var s=this,refQty={},groups={},fixes=[];
    (cart.items||[]).forEach(function(it){var p=it.properties||{};if(!p._yk_addon){if(p._yk_ref)refQty[p._yk_ref]=(refQty[p._yk_ref]||0)+(it.quantity||0);return}var sig=it.variant_id+'|'+s.norm(p);(groups[sig]=groups[sig]||[]).push(it)});
    Object.keys(groups).forEach(function(sig){
      var g=groups[sig],p=g[0].properties||{};
      var have=g.reduce(function(a,x){return a+(x.quantity||0)},0),want=p._yk_ref?(refQty[p._yk_ref]||0):0;
      if(have===want)return;
      if(have>want){var excess=have-want;for(var i=g.length-1;i>=0&&excess>0;i--){var take=Math.min(excess,g[i].quantity);fixes.push({key:g[i].key,qty:g[i].quantity-take});excess-=take}}
      else fixes.push({key:g[0].key,qty:g[0].quantity+(want-have)});
    });
    return fixes;
  },
  reconcilePlan(cart){var p=this.planAll(cart);return p.length?p[0]:null},
  async reconcile(cart){
    for(var i=0;i<4;i++){
      var m=this.planMap(cart);
      if(!Object.keys(m).length)return cart;
      try{cart=await this.applyUpdates(cart,m,this._pending<=0)}catch(e){console.error('[reconcile]',e);cart=await this.getCart()}
    }
    return cart;
  },
  reconcileHiddenItems(cart){return this.reconcile(cart)},

  /* ---- Rendu : remplace jauge / corps / pied par le HTML de la section (reçu avec la réponse du panier), en un seul frame */
  async applyHtml(html,cart){
    if(!html)return;
    var s=this,doc=new DOMParser().parseFromString(html,'text/html');
    var emb=this.readEmbedded(doc);
    if(emb){if(this.isCart(cart)&&!cart.embedded){emb.discount_codes=cart.discount_codes||emb.discount_codes;emb.cart_level_discount_applications=cart.cart_level_discount_applications||emb.cart_level_discount_applications}this._last=this._cart=emb}
    else if(this.isCart(cart))this._last=this._cart=cart;
    var wait=Math.max(0,this._holdUntil-performance.now());
    if(wait)await new Promise(function(r){setTimeout(r,wait)});
    await raf();
    /* lectures */
    var prev=new Set([].slice.call(this.d.querySelectorAll('.yk-item')).map(function(el){return s.idOf(el)}));
    var badge=document.getElementById('ykC'),prevCount=badge?parseInt(badge.textContent,10)||0:0;
    var opened=this.d.classList.contains('on');
    /* écritures */
    ['ykGauge','ykBody','ykFoot'].forEach(function(id){var n=doc.getElementById(id),el=document.getElementById(id);if(n&&el){if(el.replaceChildren)el.replaceChildren.apply(el,[].slice.call(n.childNodes).map(function(x){return document.adoptNode(x)}));else el.innerHTML=n.innerHTML;el.className=n.className;el.hidden=n.hidden}});
    if(opened)this.d.querySelectorAll('.yk-item').forEach(function(el){if(!prev.has(s.idOf(el)))el.classList.add('in')});
    var realCount=0;(this._cart&&this._cart.items||[]).forEach(function(it){var p=it.properties||{};if(!(p._hidden||p._yk_addon||p._yk_gift))realCount+=it.quantity||0});
    if(badge){badge.textContent=realCount;if(realCount!==prevCount){badge.classList.remove('pulse');void badge.offsetWidth;badge.classList.add('pulse')}}
    this.syncHeaderCount(realCount);
    if(realCount===0){this.ui.openKeys=[];this.ui.badgeKeys=[]}
    this.afterRender();
    this._holdUntil=0;
  },

  /* Pop-up d'ajout (upsell / meilleures ventes) */
  openAdd(btn){
    var ds=btn&&btn.dataset||{};
    var img=ds.img||(function(){var i=btn&&btn.closest('.yk-up');i=i&&i.querySelector('img');return i?i.currentSrc||i.src:''})();
    this.addCtx={vid:ds.vid,title:ds.title||'',img:img,price:parseInt(ds.price||'0',10),compare:parseInt(ds.compare||'0',10),size:'M',short:false,player:false};
    var m=document.getElementById('ykAdd');if(!m)return;
    document.getElementById('ykAddTitle').textContent=this.addCtx.title;
    var im=document.getElementById('ykAddImg');if(this.addCtx.img){im.src=this.addCtx.img;im.alt=this.addCtx.title;im.hidden=false}else{im.removeAttribute('src');im.hidden=true}
    document.getElementById('ykAddPrice').textContent=this.money(this.addCtx.price);
    var cmp=document.getElementById('ykAddCompare');if(this.addCtx.compare>this.addCtx.price){cmp.textContent=this.money(this.addCtx.compare);cmp.hidden=false}else cmp.hidden=true;
    m.querySelectorAll('#ykAddSizes .yk-chip').forEach(function(b){b.classList.toggle('on',b.dataset.sz==='M')});
    ['ykAddName','ykAddNum','ykAddSub'].forEach(function(id){document.getElementById(id).value=''});
    ['ykAddShort','ykAddPlayer'].forEach(function(id){var b=document.getElementById(id);b.classList.remove('on');b.setAttribute('aria-checked','false')});
    var err=document.getElementById('ykAddErr');err.hidden=true;
    var go=document.getElementById('ykAddGo');go.disabled=false;go.classList.remove('busy');
    this.updateAddTotal();
    m.classList.add('on');
    m.querySelector('.yk-add__card').scrollTop=0;
  },
  closeAdd(){var m=document.getElementById('ykAdd');if(m)m.classList.remove('on');this.addCtx=null},
  updateAddTotal(){
    var c=this.addCtx;if(!c)return;var p=this.cfg().prices;
    var n=['ykAddName','ykAddNum','ykAddSub'].filter(function(id){return (document.getElementById(id).value||'').trim()}).length;
    var tot=c.price+(p.floc||0)*n+(c.short?(p.short||0):0)+(c.player?(p.vplayer||0):0);
    document.getElementById('ykAddTotal').textContent=this.money(tot);
  },
  handleAddClick(e){
    if(e.target.closest('#ykAddX')||e.target.id==='ykAdd'){this.closeAdd();return}
    var sz=e.target.closest('#ykAddSizes .yk-chip');
    if(sz){document.querySelectorAll('#ykAddSizes .yk-chip').forEach(function(b){b.classList.remove('on')});sz.classList.add('on');this.addCtx.size=sz.dataset.sz;return}
    var sh=e.target.closest('#ykAddShort');
    if(sh){this.addCtx.short=!this.addCtx.short;sh.classList.toggle('on',this.addCtx.short);sh.setAttribute('aria-checked',String(this.addCtx.short));this.updateAddTotal();return}
    var pl=e.target.closest('#ykAddPlayer');
    if(pl){this.addCtx.player=!this.addCtx.player;pl.classList.toggle('on',this.addCtx.player);pl.setAttribute('aria-checked',String(this.addCtx.player));this.updateAddTotal();return}
    if(e.target.closest('#ykAddGo')){this.confirmAdd();return}
  },
  async confirmAdd(){
    var c=this.addCtx,s=this;if(!c||this._adding)return;
    var err=document.getElementById('ykAddErr');err.hidden=true;
    if(!c.size){err.textContent='Choisis une taille';err.hidden=false;return}
    this._adding=true;var go=document.getElementById('ykAddGo');go.disabled=true;go.classList.add('busy');
    var ids=this.cfg().ids;
    var ref=this.newRef();
    var name=(document.getElementById('ykAddName').value||'').trim().toUpperCase(),num=(document.getElementById('ykAddNum').value||'').trim(),sub=(document.getElementById('ykAddSub').value||'').trim().toUpperCase();
    var props={'Taille':c.size,'_yk_ref':ref};
    if(name)props['Nom']=name;if(num)props['Numéro']=num;if(sub)props['Sous-numéro']=sub;
    if(c.short)props['Short assorti']='Taille '+c.size;
    if(c.player)props['Version Player']='Oui';
    var items=[{id:parseInt(c.vid,10),quantity:1,properties:props}];
    if(name)items.push({id:ids.floc,quantity:1,properties:{'Pour':c.title,'Texte':name,'_yk_ref':ref,'_yk_addon':'1'}});
    if(num)items.push({id:ids.floc,quantity:1,properties:{'Pour':c.title,'Numéro':num,'_yk_ref':ref,'_yk_addon':'1'}});
    if(sub)items.push({id:ids.floc,quantity:1,properties:{'Pour':c.title,'Texte':sub,'Position':'Sous le numéro','_yk_ref':ref,'_yk_addon':'1'}});
    if(c.short)items.push({id:ids.short,quantity:1,properties:{'Pour':c.title,'Taille':c.size,'_yk_ref':ref,'_yk_addon':'1'}});
    if(c.player)items.push({id:ids.vplayer,quantity:1,properties:{'Pour':c.title,'_yk_ref':ref,'_yk_addon':'1'}});
    await this.queue(async function(){
      var res=await s.addItems(items);
      if(!res.ok){var j=res.data||{};var e2=document.getElementById('ykAddErr');if(e2){e2.textContent=j.description||j.message||"Erreur lors de l'ajout, réessaie";e2.hidden=false}throw new Error(j.description||j.message||'Ajout impossible')}
      s.closeAdd();
      return res.render;
    },'confirmAdd');
    go.disabled=false;go.classList.remove('busy');this._adding=false;
  },

  /* Note de commande : enregistrée 800 ms après la dernière frappe (aucun rendu nécessaire) */
  scheduleNote(v,now){
    var s=this;
    clearTimeout(this._noteT);
    this._noteT=setTimeout(async function(){
      try{var r=await s.post('/cart/update.js',{note:v});if(r.ok&&r.data&&r.data.items)s._last=r.data}catch(e){console.error('[note]',e)}
      var l=document.getElementById('ykNoteBtnL'),b=document.getElementById('ykNoteBtn');
      if(l)l.textContent=v.trim()?'Note ajoutée':'Note de commande';
      if(b)b.classList.toggle('yk-fbtn--ok',!!v.trim());
    },now?0:800);
  },

  /* Rafraîchissement complet : un seul rendu de section (état embarqué inclus), passé par la file */
  refresh(silent){
    var s=this;
    if(!silent)this.loading(true);
    var p=this.queue(async function(){var html=await s.fetchSection();var o={sections:{}};o.sections[SECTION]=html;return o},'refresh');
    return p.then(function(){if(!silent)s.loading(false)},function(){if(!silent)s.loading(false)});
  },

  async add(vid,qty,props){
    qty=qty||1;props=props||{};
    var s=this;
    this.open();this.loading(true);
    try{
      await this.queue(async function(){
        var res=await s.addItems([{id:parseInt(vid,10),quantity:qty,properties:props}]);
        if(!res.ok)throw new Error((res.data&&res.data.description)||'Add failed');
        return res.render;
      },'add');
    }catch(e){console.error('[add]',e)}
    this.loading(false);
  },
  async quickAdd(vid){return this.add(vid,1,{})},

  goCheckout(){window.location.href='/checkout'},

  /* Code promo : Shopify l'applique au panier et le valide (minimum d'achat, limites d'usage, livraison offerte) ; le total est
     recalculé côté serveur et le code suit au paiement. Un code refusé est retiré du panier. */
  async applyPromo(){
    var input=document.getElementById('ykPromoInput'),btn=document.getElementById('ykPromoApply'),errEl=document.getElementById('ykPromoErr');
    if(!input)return;
    var code=input.value.trim();
    if(errEl)errEl.hidden=true;
    if(!code){input.focus();return}
    if(this._promoBusy)return;this._promoBusy=true;
    if(btn){btn.disabled=true;btn.textContent='…'}
    var s=this;
    try{
      var r=await this.post('/cart/update.js',{discount:code,sections:SECTION});
      var cart=r.data||{};
      var dc=(cart.discount_codes||[]).find(function(d){return String(d.code).toLowerCase()===code.toLowerCase()});
      if(!r.ok||!dc||!dc.applicable){
        var r2=await this.post('/cart/update.js',{discount:'',sections:SECTION}).catch(function(){return null});
        var c2=r2&&r2.ok?r2.data:null;if(c2)this._last=c2;
        this.ui.promoOpen=true;
        await this.queue(async function(){return c2},'promo'); /* attend la fin des actions en cours (le pied peut être re-rendu entre-temps) */
        var e2=document.getElementById('ykPromoErr'),i2=document.getElementById('ykPromoInput'),b2=document.getElementById('ykPromoApply');
        if(e2){e2.textContent="Code invalide ou conditions non remplies (minimum d'achat, code déjà utilisé…)";e2.hidden=false}
        if(i2)i2.value=code;
        if(b2){b2.disabled=false;b2.textContent='Appliquer'}
        this._promoBusy=false;return;
      }
      this._last=cart;
      this.closeSheet();
      await this.queue(async function(){return cart},'promo'); /* même file que les autres actions : pas de rendus croisés */
    }catch(e){
      console.error('[promo]',e);
      var e3=document.getElementById('ykPromoErr'),b3=document.getElementById('ykPromoApply');
      if(e3){e3.textContent='Impossible de vérifier le code, réessaie';e3.hidden=false}
      if(b3){b3.disabled=false;b3.textContent='Appliquer'}
    }
    var b4=document.getElementById('ykPromoApply');if(b4&&b4.textContent==='…'){b4.disabled=false;b4.textContent='Appliquer'}
    this._promoBusy=false;
  },
  /* État « code appliqué » (discount_codes + remises de niveau panier, depuis la réponse API ou l'état embarqué) */
  renderPromo(cart){
    var box=document.getElementById('ykPromo'),row=document.getElementById('ykPromoRow'),lab=document.getElementById('ykPromoBtnL'),btn=document.getElementById('ykPromoBtn');
    if(!box)return;
    var old=document.getElementById('ykPromoApplied');if(old)old.remove();
    var dc=(cart.discount_codes||[]).find(function(d){return d.applicable}),ap=document.getElementById('ykPromoApply');
    if(!dc){if(row)row.hidden=false;if(ap)ap.hidden=false;if(lab)lab.textContent='Code promo';if(btn)btn.classList.remove('yk-fbtn--ok');return}
    var code=String(dc.code).toUpperCase();
    /* /cart/update.js renvoie {amount, discount_application:{…}} là où /cart.js renvoie l'objet à plat */
    var apps=(cart.cart_level_discount_applications||[]).map(function(a){return a&&a.discount_application?Object.assign({total_allocated_amount:a.amount},a.discount_application):a}).filter(function(a){return a&&a.type==='discount_code'});
    var amount=apps.reduce(function(t,a){return t+(a.total_allocated_amount||0)},0);
    var pct=apps.find(function(a){return a.value_type==='percentage'});
    var detail=amount>0?('· −'+this.money(amount)+(pct?' (−'+String(pct.value).replace(/\.0$/,'')+' %)':'')):(cart.total_discount>0?'· remise appliquée':'· livraison offerte, appliquée au paiement');
    if(row)row.hidden=true;if(ap)ap.hidden=true;
    var ok=document.createElement('div');ok.className='yk-promo__ok';ok.id='ykPromoApplied';
    ok.innerHTML='<svg width="17" height="14" viewBox="0 0 10 8" fill="none" aria-hidden="true"><path d="M1.5 3.5 3.8 6l4.7-5" stroke="currentColor" stroke-width="2"/></svg><span>Code <strong></strong> appliqué <em></em></span><button type="button" class="yk-promo__rm" id="ykPromoRemove" aria-label="Retirer le code">×</button>';
    ok.querySelector('strong').textContent=code;ok.querySelector('em').textContent=detail;
    if(ap)box.insertBefore(ok,ap);else box.appendChild(ok);
    if(lab)lab.textContent='Code '+code+' ✓';if(btn)btn.classList.add('yk-fbtn--ok');
  },
  async removePromo(){
    if(this._promoBusy)return;this._promoBusy=true;
    var cart=null;
    try{var r=await this.post('/cart/update.js',{discount:'',sections:SECTION});if(r.ok)cart=r.data}catch(e){console.error('[promo]',e)}
    if(cart)this._last=cart;
    this.ui.promoOpen=true;
    await this.queue(async function(){return cart},'promo');
    this._promoBusy=false;
  }
};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){window.ykCart.init()});else window.ykCart.init();
})();
